// extracted by mini-css-extract-plugin
export default {"content":"content_content__oZRf5","active":"content_active__ws7zR","container":"content_container__kV4yQ","audioPlayer":"content_audioPlayer__WsJFv"};